module.exports = __webpack_public_path__ + "img/619238d.svg";